import clsx from 'clsx';

import { Typography } from '@/components/core';

import styles from './Chip.module.scss';

interface ChipProps {
    text: string;
    className?: string;
    colorId: number;
}

export const Chip: React.FC<ChipProps> = ({ text, className, colorId }) => (
    <div className={clsx(styles.root, className, styles[`color-${colorId}`])}>
        <Typography looksLike="tag">{text}</Typography>
    </div>
);
